module.exports = __webpack_public_path__ + "img/like.8bc7bf68.svg";